import { Yup } from 'cng-web-lib'

function MassUpdatePTTMakeValidationSchema() {
  const ssnPattern = /^\d{3}-\d{2}-\d{4}$/;
  const cbpPattern = /^\d{4}[a-zA-Z0-9]{2}-\d{5}$/;
  const irsPattern = /^\d{2}-\d{7}[a-zA-Z0-9]{0,2}$/;

  return Yup.object({
    firmsCode: Yup.string().nullable(),

    bondedCarrierType: Yup.string()
      .nullable()
      .when('bondedCarrier', {
        is: (val) => val != null && val.trim() !== '',
        then: Yup.string().required('Bonded Carrier Type is required when Bonded Carrier is provided'),
        otherwise: Yup.string().nullable(),
      }),

    bondedCarrier: Yup.string()
      .nullable()
      .test(
        'pattern-and-type-required',
        function (value) {
          const { bondedCarrierType } = this.parent

          if (value && (!bondedCarrierType || bondedCarrierType.trim() === '')) {
            return this.createError({
              message: 'Bonded Carrier Type is required when Bonded Carrier is provided',
            })
          }

          if (!value) {
            return true
          }
          switch (bondedCarrierType) {
            case 'SSN':
              return ssnPattern.test(value) || this.createError({ message: 'Incorrect Bonded Carrier ID, format: 123-45-6789' })
            case 'CBP':
              return cbpPattern.test(value) || this.createError({ message: 'Incorrect Bonded Carrier ID, format: 123456-12345' })
            case 'IRS':
              return irsPattern.test(value) || this.createError({ message: 'Incorrect Bonded Carrier ID, format: 12-1234567XX' })
            default:
              return true
          }
        }
      ),
  })
}

export default MassUpdatePTTMakeValidationSchema
